import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Swap Talence render error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-[#FFF4E8]">
          <div className="max-w-md w-full rounded-2xl bg-white border border-slate-200 p-6 shadow-sm">
            <h1 className="text-xl font-bold text-slate-900 mb-2">Erreur au chargement</h1>
            <p className="text-sm text-slate-600 mb-4">
              L&apos;application n&apos;a pas pu démarrer. Recharge la page ou réessaie plus tard.
            </p>
            <pre className="text-xs bg-slate-50 p-3 rounded-lg overflow-auto text-red-700 mb-4">
              {this.state.error?.message || String(this.state.error)}
            </pre>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="w-full py-2.5 rounded-xl font-semibold text-white"
              style={{ backgroundColor: '#FF6B4A' }}
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
